import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { QUERY_KEYS } from '~shared/api/query-keys';

export interface BulkUploadResponse {
  success: boolean;
  jobId: string;
  message: string;
  totalRecords: number;
  validationErrors: Array<{
    record: Record<string, string | number | undefined>;
    error: string;
  }>;
  estimatedTime?: string;
}

export const bulkUploadClassesAPI = async (file: File) => {
  const formData = new FormData();
  formData.append('classes', file);

  const resp = await baseAPI.post<BulkUploadResponse>(
    '/enrollments/bulk-import',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );
  return resp.data;
};

export const useBulkUploadClassesMutation = () => {
  return useMutation<BulkUploadResponse, Error, File>({
    mutationFn: async (file: File) => {
      const response = await bulkUploadClassesAPI(file);
      return response;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: QUERY_KEYS.CLASSES(),
      });
    },
  });
};
